export const TAX_BRACKETS = {
  annual: [
    { limit: 36000, rate: 0.03 },
    { limit: 144000, rate: 0.10 },
    { limit: 300000, rate: 0.20 },
    { limit: 420000, rate: 0.25 },
    { limit: 660000, rate: 0.30 },
    { limit: 960000, rate: 0.35 },
    { limit: Infinity, rate: 0.45 },
  ],
  bonus: [
    { limit: 3000, rate: 0.03, deduction: 0 },
    { limit: 12000, rate: 0.10, deduction: 210 },
    { limit: 25000, rate: 0.20, deduction: 1410 },
    { limit: 35000, rate: 0.25, deduction: 2660 },
    { limit: 55000, rate: 0.30, deduction: 4410 },
    { limit: 80000, rate: 0.35, deduction: 7160 },
    { limit: Infinity, rate: 0.45, deduction: 15160 },
  ],
};

export const TAX_FREE_ALLOWANCE = 5000 * 12;

export const INSURANCE_RATE = 0.104;
export const HOUSING_FUND_RATE = 0.09;
export const COMPANY_HOUSING_FUND_RATE = 0.09; // Example rate for company contribution

// Yearly limits (insurance/housing fund bases, province-city mapping) are loaded at runtime.
// See `src/utils/limitsContext.tsx` and `src/data/limits.2025.json`.